import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgAndroidPhone(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="8 5 44 46"
      fill="none"
      {...props}
    >
      <path
        fill={props.primaryColor}
        fillRule="evenodd"
        d="M22.725 8.267a1.387 1.387 0 0 1 1.922.385l1.64 2.46a12.5 12.5 0 0 1 2.754-.304h2.773q1.42.002 2.755.305l1.639-2.46a1.386 1.386 0 1 1 2.308 1.536l-1.246 1.87c3.08 1.497 5.465 4.216 6.463 7.544a4.16 4.16 0 0 1 6.1 3.684v11.095a4.16 4.16 0 0 1-5.548 3.925v.235a5.555 5.555 0 0 1-5.547 5.548v4.16a4.16 4.16 0 1 1-8.322-.005 4.18 4.18 0 0 1-1.85 3.467 4.16 4.16 0 0 1-6.471-3.461V44.09a5.557 5.557 0 0 1-5.547-5.548v-.235A4.162 4.162 0 0 1 11 34.382V23.287a4.16 4.16 0 0 1 6.1-3.684 12.48 12.48 0 0 1 6.462-7.544l-1.245-1.87a1.387 1.387 0 0 1 .386-1.922zm-6.158 26.129V23.3a1.387 1.387 0 1 0-2.774 0v11.095a1.387 1.387 0 1 0 2.774 0M19.34 23.3a1.387 1.387 0 0 0 1.387 1.387h19.416A1.387 1.387 0 0 0 41.53 23.3c0-5.354-4.355-9.708-9.708-9.708h-2.774c-5.353 0-9.708 4.354-9.708 9.708m24.963 11.095a1.387 1.387 0 0 0 2.774 0V23.3a1.387 1.387 0 1 0-2.774 0zm-2.773-5.548a1.387 1.387 0 0 0-1.387-1.387H20.728a1.387 1.387 0 0 0-1.387 1.387v9.708a2.774 2.774 0 0 0 2.773 2.774h1.387a1.387 1.387 0 0 1 1.387 1.387v5.547a1.387 1.387 0 1 0 2.774 0v-5.547a1.387 1.387 0 0 1 1.387-1.387h2.774a1.387 1.387 0 0 1 1.386 1.387v5.547a1.387 1.387 0 1 0 2.774 0v-5.547a1.387 1.387 0 0 1 1.387-1.387h1.387a2.774 2.774 0 0 0 2.774-2.774z"
        clipRule="evenodd"
      />
      <path
        fill={props.secondaryColor}
        d="M27.256 18.734a1.387 1.387 0 1 0-1.962-1.962 1.387 1.387 0 0 0 1.962 1.962M35.577 18.734a1.387 1.387 0 1 1-1.961-1.96 1.387 1.387 0 0 1 1.961 1.96"
      />
    </svg>
  );
}
export default SvgAndroidPhone;
